import React, { PureComponent } from 'react';

interface ExpandToggleButtonProps {
  handleClick: Function;
  isExpanded: boolean;
  isBulkDataAdded?: boolean;
}

class ExpandToggleButton extends PureComponent<ExpandToggleButtonProps> {

  setImage = () => {
    const { isExpanded, isBulkDataAdded } = this.props;
    // if (isBulkDataAdded) {
    //   return '/assets/svg/editOutline.svg';
     if (isExpanded) {
      return '/assets/img/course/remove.png'
    } else {
      return '/assets/img/course/add.png'
    }
  }

  handleStyle = () =>{
    const { isExpanded, isBulkDataAdded } = this.props;

    const style = {
      position: "absolute",
      width:10,
      height:10,
      backgroundColor: "red",
      borderRadius: "50%",
      right:-5,
      top:-5,
    }
   return isBulkDataAdded? style: {}
  }
  render = () => {
    const { handleClick, isExpanded, isBulkDataAdded } = this.props;
    return (
      // <span>
      <button
        style={{
          backgroundColor: "white",
          border: "1px solid #333",
          color: "#333",
          outline: "none",
          width: 20,
          height: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 3,
          marginRight: 10,
          padding: 5,
          position: 'relative',
          cursor: 'pointer',
        }}
        onClick={() => handleClick()}
      >
        {/* <span> */}
          <img
            src={this.setImage()}
            alt='expand-shrink-icon'
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: 15,
              height: 15,
              display: "block",
              transform: "translate(-50%, -50%)",
            }}
          /> 
          {isBulkDataAdded && <span style={this.handleStyle()}></span>}
        {/* </span> */}
      </button>
      // </span>
    );
  };
}

export default ExpandToggleButton;
